import InvitePhysicianForm from './InvitePhysicianForm';
import NewPermanentLinkModal from './NewPermanentLinkModal';
import PhysicianInvitePhysician from './PhysicianInvitePhysician';

PhysicianInvitePhysician.InvitePhysicianForm = InvitePhysicianForm;

export { PhysicianInvitePhysician as default, NewPermanentLinkModal };
